import { Link } from "react-router-dom";
import React from "react";
const VacaturesMenu = ({ token, username, isActive, onToggle }) => {
  if (username.bedrijf && username.bedrijf.modules.includes("vacatures")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker") {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon"><i className="fas fa-user-check"></i></span>
            <span className="menu-text">Vacatures</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}><i className="fas fa-chevron-right"></i></span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/vacatures" className="menu-link">
                <span className="menu-icon"><i className="fa fa-person"></i></span>
                <span className="menu-text">Vacatures</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/vacatures/bedrijven" className="menu-link">
                <span className="menu-icon"><i className="fa fa-building"></i></span>
                <span className="menu-text">Bedrijven</span>
              </Link>
            </div>
      
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default VacaturesMenu;
